import * as moment from "moment";


export class PeriodEvent {
  contraception?: Array<number> = [];
  date: string = '';
  dateCreated: string = moment().format('YYYY-MM-DD');
  diet?: Array<number> = [];
  id?: string = '';
  medication?: Array<number> = [];
  moods?: Array<number> = [];
  sex?: Array<number> = [];
  discharge?: number;
  flow?: number;
  supplements?: Array<number> = [];
  symptoms?: Array<number> = [];
  note?: string = '';
}